export default "images/038 停车让行.png";